module.exports = __webpack_public_path__ + "img/adopciones5.eb09b0e2.jpg";